import { PRODUCT_MIN_PRICE } from 'appConstants';
import { t } from 'i18next';
import * as yup from 'yup';

import type { IValidationField } from '../types';

export default function packagedItemPrice({ label = '', context = {} }: IValidationField) {
  const { min, max, required = true } = context;

  let validation = yup
    .number()
    .label(label)
    .typeError(`${label} ${t('errors.number')}`)
    .transform((value) => (isNaN(value) ? undefined : value))
    .nullable()
    .min(min || PRODUCT_MIN_PRICE);

  if (required) validation = validation.required();

  if (max) validation = validation.max(max);
  return validation;
}
